import { render } from "./ActiveDisputesCountCheckDescription.vue?vue&type=template&id=b66ff17a&ts=true"
import script from "./ActiveDisputesCountCheckDescription.vue?vue&type=script&lang=ts"
export * from "./ActiveDisputesCountCheckDescription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__